/**
 * @generated SignedSource<<f8cb29a69672ff5afeae52c3b234c1de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogPost_Query$variables = {
  slug: string;
};
export type BlogPost_Query$data = {
  readonly blogPost: {
    readonly " $fragmentSpreads": FragmentRefs<"BlogPost_BlogPostFragment">;
  } | null | undefined;
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"BlogPost_User" | "auth_checkAuthForPage">;
  } | null | undefined;
};
export type BlogPost_Query = {
  response: BlogPost_Query$data;
  variables: BlogPost_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unconfirmedEmail",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confirmedEmail",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passwordSetupRequired",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "statuses": [
        "active",
        "paused"
      ]
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableTimesheets",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowExpensesAccess",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentsEnabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v13 = {
  "alias": "offers",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "statuses": [
          "offer_made"
        ]
      }
    },
    (v11/*: any*/)
  ],
  "concreteType": "ContractConnection",
  "kind": "LinkedField",
  "name": "freelancerContracts",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "freelancerContracts(filters:{\"statuses\":[\"offer_made\"]},first:0)"
},
v14 = {
  "alias": "interviews",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "stage": "interview"
      }
    },
    (v11/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"stage\":\"interview\"},first:0)"
},
v15 = {
  "alias": "screening",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "withJobScreening": true
      }
    },
    (v11/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"withJobScreening\":true},first:0)"
},
v16 = {
  "alias": "applications",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "statuses": [
          "job_application_sent",
          "job_application_draft"
        ]
      }
    },
    (v11/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"statuses\":[\"job_application_sent\",\"job_application_draft\"]},first:0)"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v18 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isMember",
  "selections": [
    (v1/*: any*/),
    (v17/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isClient",
  "storageKey": null
},
v20 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isClient",
  "selections": [
    (v1/*: any*/),
    (v19/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guest",
  "storageKey": null
},
v22 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isGuest",
  "selections": [
    (v21/*: any*/),
    (v1/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v23 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v25 = [
  (v10/*: any*/),
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Video",
  "kind": "LinkedField",
  "name": "video",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optimizedUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "posterUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableSubtitles",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogPost_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BlogPost_User"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "auth_checkAuthForPage",
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "auth_getRedirectPath",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "auth_getDefaultPath",
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v1/*: any*/),
                      {
                        "alias": "activeContracts",
                        "args": (v6/*: any*/),
                        "concreteType": "ContractConnection",
                        "kind": "LinkedField",
                        "name": "freelancerContracts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contract",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Firm",
                                "kind": "LinkedField",
                                "name": "firm",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
                      },
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v18/*: any*/),
                      (v20/*: any*/),
                      (v22/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  (v22/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v23/*: any*/),
        "concreteType": "BlogPost",
        "kind": "LinkedField",
        "name": "blogPost",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BlogPost_BlogPostFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BlogPost_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v21/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": "activeContracts",
            "args": (v6/*: any*/),
            "concreteType": "ContractConnection",
            "kind": "LinkedField",
            "name": "freelancerContracts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Contract",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Firm",
                    "kind": "LinkedField",
                    "name": "firm",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  (v24/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v19/*: any*/),
          (v24/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v23/*: any*/),
        "concreteType": "BlogPost",
        "kind": "LinkedField",
        "name": "blogPost",
        "plural": false,
        "selections": [
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "excerpt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatarUrl",
                "storageKey": null
              },
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "self",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visibility",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "openToOpportunities",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Industry",
                    "kind": "LinkedField",
                    "name": "industry",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canMakeOffer",
                "storageKey": null
              },
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogCategory",
            "kind": "LinkedField",
            "name": "blogCategories",
            "plural": true,
            "selections": [
              (v26/*: any*/),
              (v10/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogSubcategory",
            "kind": "LinkedField",
            "name": "blogSubcategories",
            "plural": true,
            "selections": [
              (v26/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BlogCategory",
                "kind": "LinkedField",
                "name": "blogCategory",
                "plural": false,
                "selections": (v25/*: any*/),
                "storageKey": null
              },
              (v24/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "89ddede2cafcaf0dca57a2684863ae6f",
    "id": null,
    "metadata": {},
    "name": "BlogPost_Query",
    "operationKind": "query",
    "text": "query BlogPost_Query(\n  $slug: String!\n) {\n  currentUser {\n    ...BlogPost_User\n    ...auth_checkAuthForPage\n    id\n  }\n  blogPost(slug: $slug) {\n    ...BlogPost_BlogPostFragment\n    id\n  }\n}\n\nfragment BlogPostContent_BlogPost on BlogPost {\n  user {\n    id\n    self\n  }\n  slug\n  status\n  title\n  content\n  blogCategories {\n    name\n    slug\n    id\n  }\n  blogSubcategories {\n    name\n    slug\n    blogCategory {\n      slug\n      id\n    }\n    id\n  }\n  ...MetaInfo_BlogPostFragment\n}\n\nfragment BlogPostLanding_BlogPost on BlogPost {\n  id\n  title\n  ...BlogPostContent_BlogPost\n  ...ProfileHireBox_BlogPostFragment\n}\n\nfragment BlogPostSignedIn_BlogPost on BlogPost {\n  id\n  slug\n  title\n  user {\n    profile {\n      slug\n      id\n    }\n    id\n  }\n  ...BlogPostContent_BlogPost\n  ...MetaInfo_BlogPostFragment\n  ...ProfileHireBox_BlogPostFragment\n}\n\nfragment BlogPost_BlogPostFragment on BlogPost {\n  id\n  title\n  status\n  excerpt\n  content\n  user {\n    name\n    avatarUrl\n    id\n  }\n  updatedAt\n  ...BlogPostLanding_BlogPost\n  ...BlogPostSignedIn_BlogPost\n}\n\nfragment BlogPost_User on User {\n  ...user_useIsGuest\n}\n\nfragment MetaInfo_BlogPostFragment on BlogPost {\n  status\n  updatedAt\n  user {\n    name\n    avatarUrl\n    profile {\n      slug\n      id\n    }\n    id\n  }\n}\n\nfragment ProfileHireBox_BlogPostFragment on BlogPost {\n  video {\n    ...Video_Video\n    id\n  }\n  user {\n    id\n    name\n    canMakeOffer\n    ...UserAvatarContainer_User\n    video {\n      ...Video_Video\n      id\n    }\n    profile {\n      visibility\n      openToOpportunities\n      slug\n      industry {\n        name\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment Video_Video on Video {\n  id\n  url\n  optimizedUrl\n  posterUrl\n  enableSubtitles\n}\n\nfragment auth_checkAuthForPage on User {\n  ...auth_getRedirectPath\n}\n\nfragment auth_getDefaultPath on User {\n  confirmedEmail\n  passwordSetupRequired\n  status\n  activeContracts: freelancerContracts(first: 1, filters: {statuses: [active, paused]}) {\n    nodes {\n      enableTimesheets\n      allowExpensesAccess\n      paymentsEnabled\n      firm {\n        slug\n        id\n      }\n      id\n    }\n  }\n  offers: freelancerContracts(first: 0, filters: {statuses: [offer_made]}) {\n    totalCount\n  }\n  interviews: freelancerJobApplications(first: 0, filters: {stage: interview}) {\n    totalCount\n  }\n  screening: freelancerJobApplications(first: 0, filters: {withJobScreening: true}) {\n    totalCount\n  }\n  applications: freelancerJobApplications(first: 0, filters: {statuses: [job_application_sent, job_application_draft]}) {\n    totalCount\n  }\n  ...user_isMember\n  ...user_isClient\n  ...user_isGuest\n}\n\nfragment auth_getRedirectPath on User {\n  status\n  unconfirmedEmail\n  confirmedEmail\n  integrationName\n  ...auth_getDefaultPath\n  ...user_isGuest\n  ...user_isMember\n  ...user_isClient\n}\n\nfragment user_isClient on User {\n  status\n  isClient\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_isMember on User {\n  status\n  isMember\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n"
  }
};
})();

(node as any).hash = "51b9ca6c0a242848f6f955529012a9b6";

export default node;
